<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Input from '@components/Input.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import CreatorSpotlightAjax from '@ajax/creator_spotlight';
  let user = getCurrentUserStore('default');

  const dispatch = createEventDispatcher();

  export let mobile = false;
  let info = {
    birthday: null,
    location: null,
    job_title: null,
    school: null,
  };

  let loadUserBasicInformation = async function () {
    let res = await CreatorSpotlightAjax.getBasicInformation();
    info = res.basic_information;
  };

  let updateUserBasicInformation = async function () {
    let res = await CreatorSpotlightAjax.updateBasicInformation(user, info);

    return res;
  };

  loadUserBasicInformation();
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-basic-info {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      margin-bottom: 16px;
      color: #717171;
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }

  .info-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
    max-width: 340px;
    margin: 20px auto 24px;
  }

  * :global(input[type='date']::-webkit-inner-spin-button),
  * :global(input[type='date']::-webkit-calendar-picker-indicator) {
    opacity: 0;
  }

  * :global(.input-label) {
    color: #000;
    font-weight: 500 !important;
    opacity: 1 !important;
  }

  * :global(.input-label-container) {
    margin-bottom: 8px !important;
  }

  .input-sub-label {
    color: #717171;
    font-size: 12px;
    margin-top: 4px;
  }
</style>

<div class="creator-spotlight-basic-info" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Basic Info</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>

  <div class="info-container">
    <Input
      bind:value={info.location}
      label="Town/City"
      focus={true}
      placeholder="Where you live"
      labelClass="input-label"
      labelContainerClass="input-label-container"
      labelStyle="font-size: 15px; font-weight: 500; color: #000"
      on:blur={updateUserBasicInformation} />
    <Input
      bind:value={info.birthday}
      label="Birthday"
      placeholder="MM/DD/YYYY"
      labelClass="input-label"
      labelContainerClass="input-label-container"
      type="date"
      on:blur={updateUserBasicInformation}>
      <svelte:fragment slot="sub-label">
        <div class="input-sub-label">Your profile will show your age, not your birthday.</div>
      </svelte:fragment>
    </Input>
    <Input
      bind:value={info.job_title}
      label="Job Title"
      placeholder="Your profession"
      labelClass="input-label"
      labelContainerClass="input-label-container"
      on:blur={updateUserBasicInformation} />
    <Input
      bind:value={info.school}
      label="School"
      placeholder="School you attended"
      labelClass="input-label"
      labelContainerClass="input-label-container"
      on:blur={updateUserBasicInformation} />
  </div>
  <div class="finished-btn">
    <Button
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={'Continue'}
      on:click={() => {
        dispatch('finished');
      }} />
  </div>
</div>
